import { createSlice } from '@reduxjs/toolkit';
export const initialNavObjBuilderMenuState = {
  items: []
};
export const navObjBuilderMenu = 'navObjBuilderMenu';
export const navObjBuilderMenuSlice = createSlice({
  name: navObjBuilderMenu,
  initialState: initialNavObjBuilderMenuState,
  reducers: {}
});
export const {
  reducer: navObjBuilderMenuReducer,
  actions: navObjBuilderMenuActions
} = navObjBuilderMenuSlice;